const state = {
  blueprint: {
    show: false,
    title: null,
    text: null,
    textTranslate: false,
    abortCallback: null
  },
  error: {
    show: false
  }
}

// getters
const getters = {
  getError: state => {
    return state.error
  },
}

// actions
const actions = {
}

// mutations
const mutations = {
  newError (state, error) {
    error.show = true
    state.error = Object.assign(state.blueprint, error);
  },

  closeError (state) {
    state.error.show = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
